<template>
    <div class="container-fluid d-flex justify-content-between" itemscope itemtype="http://schema.org/Article">
        <div class="d-md-none d-lg-block side">
            <ul class="outline sticky" v-if="outline.length" v-show="show">
                <li v-for="v in outline" :key="'outline-' + v.id" :style="{
                    paddingLeft: v.level + 'rem',
                }" class="position-relative">
                    <a href="#" @click.prevent="scrollTo(v)" class="text-reset stretched-link" v-html="v.caption">
                    </a>
                </li>
            </ul>
        </div>
        <div class="container p-0" v-show="show">
            <h1 class="title" itemprop="name">
                {{article.title}}
                <span class="badge" :class="['badge-' + article.rating.color]" v-if="article.rating">{{article.rating.rating_name}}</span>
            </h1>
            <div class="publish-at" itemprop="dateModified">
                {{$filters.dateFormat(article.publish_at)}}
            </div>
            <editor
                id="article-viewer"
                :content="$filters.jsonParse(article.publish_article)"
                :markdown="false"
                ref="viewer"
                minHeight="0"
                :readOnly="true"
                itemprop="text"></editor>
            <div class="tags" v-if="article.tags && article.tags.length">
                <ul class="tag-list" itemprop="keywords">
                    <li v-for="t in article.tags" :key="'tag-' + t.id">
                        <router-link :to="'/search?keywords=' + encodeURI(t.tag_name)" class="black">{{t.tag_name}}</router-link>
                    </li>
                </ul>
            </div>
            <h3 class="title" v-if="related_articles && related_articles.length">関連記事</h3>
            <div class="row">
                <div class="col-md-4 mb-3" v-for="r in related_articles" :key="'articles-' + r.id">
                    <article-card
                        :article="r"></article-card>
                </div>
            </div>
        </div>
        <div class="d-md-none d-lg-block side">
            &nbsp;
        </div>
    </div>
</template>

<style scoped lang="scss">
.container {
    max-width: 820px;
}
.badge {
    font-size: .8rem;
}
.title {
    padding: 5rem 3rem 2rem;
    font-weight: bold;
}
.publish-at {
    margin: 0 3rem;
    font-size: .8rem;
    text-align: right;
    color: #aaa;
}
.tags {
    margin: 1rem 3rem;
}
.side {
    max-width: 400px;
    width: 400px;
}
.outline {
    list-style: none;
    padding-inline-start: 0;
    margin-top: 11rem;
    padding-top: 2rem;
    font-size: .8rem;
    max-height: calc(100dvh - 43px);
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar{
        display:none;
    }
    li {
        padding: .2rem .5rem .2rem;
        a {
            text-decoration: none;
        }
        &:hover {
            background-color: #aaa;
        }
    }
}
@media screen and (max-width: 770px) {
    .side {
        display: none;
    }
    .title {
        text-align: center;
        padding: 5rem .5rem 2rem;
    }
    .publish-at {
        text-align: center;
    }
    .tags {
        margin: 1rem -15px 1rem -15px;
        padding: 1rem;
        background-color: #ddd;
    }
}
</style>

<script>
import articleCard from "../articleCard";
export default {
    components: {
        articleCard,
    },
    data() {
        return {
            article: {},
            related_articles: null,
            show: false,
            outline: [],
            routeWatcher: null,
        }
    },
    head: {
        title() {
            return {
                inner: this.$store.state.bookshelf_name,
                separator: "|",
                complement: this.article.title || "記事"
            }
        },
        meta() {
            return [
                { name: "keywords", content: "Web小説,オンライン小説,縦書き小説,小説投稿,小説置き場", id: "meta-keywords" },
                { name: "description", content: this.description, id: "meta-description" }
            ]
        },
        link() {
            return [
                { rel: "canonical", href: location.origin + location.pathname, id: "canonical" },
            ]
        }
    },
    methods: {
        load(is_routing = false) {
            this.show = false;
            axios.get("/author/article", {params: {id: this.$route.params.article_id}}).then(res => {
                this.article = res.data;
                if (is_routing) {
                    $("html,body")[0].scrollTop = 0;
                } else {
                    this.$refs.viewer.refresh();
                }
                this.loadRelatedArticles();
                this.makeOutline();
                setTimeout(() => this.makeHead());
                this.show = true;
            }).catch(err => { alert.err(err.response) });
        },
        makeHead() {
            this.useHead({
                title: this.article.title + " | " + this.$store.state.bookshelf_name,
                link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ],
                meta: [
                    { name: "keywords", content: "Web小説,オンライン小説,縦書き小説,小説投稿,小説置き場", id: "meta-keywords" },
                    { name: "description", content: this.description, id: "meta-description" }
                ]
            });
        },
        loadRelatedArticles() {
            axios.get("/author/articles/related", {params: {id: this.$route.params.article_id}}).then(res => {
                this.related_articles = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        makeOutline() {
            const content = JSON.parse(this.article.publish_article);
            this.outline = [];
            for (const index in content.blocks) {
                const block = content.blocks[index];
                if (block.type === "header") {
                    this.outline.push({
                        id: block.id,
                        caption: block.data.text,
                        level: block.data.level,
                        index: index,
                    });
                }
            }
        },
        scrollTo(v) {
            const x = parseInt(v.index) + 1;
            const element = $("#article-viewer .ce-block:nth-child(" + x + ")")[0];
            const scrollTop = element.getBoundingClientRect().top + window.pageYOffset - 48;

            $("html,body").animate({scrollTop: scrollTop});
        },
    },
    computed: {
        description() {
            if (!this.article || !this.article.preface) {
                return "";
            }
            return this.$filters.truncate(this.article.preface.replace(/[\r\n]/gm, ""), 120)
        }
    },
    mounted() {
        this.load();
        this.routeWatcher = this.$watch('$route', (o, n) => {
            this.load(true);
        });
    },
    beforeRouteLeave(to, from) {
        this.routeWatcher();
    }
}
</script>